import { useEffect, useMemo } from 'react'
import { get, useFormContext, useWatch } from 'react-hook-form'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import HFMultiSelect from 'components/HFInputs/HFMultipleSelect'

import { getFieldOptions } from '../RuleSchema'

import styles from './RuleEntryOutput.module.sass'
import HFSwitchButton from 'components/HFInputs/HFSwitchButton'

const icon = (
	<svg className={styles['icon']} width='16' height='16' viewBox='0 0 16 16'>
		<path d='M8.00001 10C9.10458 10 10 9.10458 10 8.00001C10 6.89544 9.10458 6.00001 8.00001 6.00001C6.89544 6.00001 6.00001 6.89544 6.00001 8.00001C6.00001 9.10458 6.89544 10 8.00001 10Z' />
		<path d='M8.66668 2.71268V1.33334H7.33334V2.71268C6.16012 2.86225 5.06978 3.39717 4.23347 4.23347C3.39717 5.06978 2.86225 6.16012 2.71268 7.33334H1.33334V8.66668H2.71268C2.86214 9.83994 3.39702 10.9303 4.23335 11.7667C5.06968 12.603 6.16008 13.1379 7.33334 13.2873V14.6667H8.66668V13.2873C9.83994 13.1379 10.9303 12.603 11.7667 11.7667C12.603 10.9303 13.1379 9.83994 13.2873 8.66668H14.6667V7.33334H13.2873C13.1378 6.16012 12.6029 5.06978 11.7665 4.23347C10.9302 3.39717 9.8399 2.86225 8.66668 2.71268ZM8.00001 12C5.79401 12 4.00001 10.206 4.00001 8.00001C4.00001 5.79401 5.79401 4.00001 8.00001 4.00001C10.206 4.00001 12 5.79401 12 8.00001C12 10.206 10.206 12 8.00001 12Z' />
	</svg>
)

const outputInputColors = [
	styles.accentContrastColor,
	styles.accentContrastColor,
	'transparent',
	'transparent',
].join(';')

const AutomationRuleEntryOutput = ({ path, data, options }) => {
	const { getValues, setValue, formState } = useFormContext()
	const initialOption = data.output?.type
	const { i18n } = useGlobal()
	const option = useWatch({ name: `${path}.output.type` }) ?? initialOption

	// Prevent form methods reset to clear the value
	const formOptionValue = get(getValues() ?? {}, path)?.option
	useEffect(() => {
		if (!formOptionValue && option) {
			setValue(`${path}.output.type`, option)
		}
	}, [formOptionValue, option, path, setValue])

	const fieldOptions = getFieldOptions('UserIds', options)

	const errors = get(formState.errors ?? {}, path)
	const error = useMemo(() => {
		return (
			errors?.output?.type?.message ?? errors?.output?.metadata?.message
		)
	}, [errors])

	return (
		<span className={[styles['rule-output']]} data-error={error}>
			<VStack justify='space-around'>
				<HStack align='center' gap='xsmall' justify='space-between'>
					<HStack align='center'>
						{icon}
						<small className={styles['priority-label']}>
							<strong>{i18n`Users`}</strong>
						</small>
					</HStack>
					<HStack align='center' gap='xsmall'>
						<h5>{i18n`Automate?`}</h5>
						<HFSwitchButton
							className={styles['switch']}
							name={`${path}.output.automate`}
						/>
					</HStack>
				</HStack>
				<HFMultiSelect
					className={styles['value-selector']}
					placeholder={i18n`Select options`}
					tint={outputInputColors}
					name={`${path}.output.metadata`}
					options={fieldOptions}
					searchable
				/>
			</VStack>
		</span>
	)
}

export default AutomationRuleEntryOutput
